import { render, staticRenderFns } from "./VariantInfoList.vue?vue&type=template&id=1f4d2a5e&scoped=true&"
import script from "./VariantInfoList.vue?vue&type=script&lang=js&"
export * from "./VariantInfoList.vue?vue&type=script&lang=js&"
import style0 from "./VariantInfoList.vue?vue&type=style&index=0&id=1f4d2a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d2a5e",
  null
  
)

export default component.exports